import { toFaDigits } from '~/utils/faDigits'
import type { AppointmentPaymentStatus } from '~/types/booking'

export { formatRialFa } from '~/utils/money'

export const APPOINTMENT_CODE_PREFIX = 'NB'

/** Latin tracking code used for copy, filenames, and search (e.g. NB-000123). */
export function formatAppointmentCode(code: number): string {
  const safe = Number.isFinite(code) && code > 0 ? Math.trunc(code) : 0
  return `${APPOINTMENT_CODE_PREFIX}-${String(safe).padStart(6, '0')}`
}

/** Same code with Persian digits for on-screen display. */
export function formatAppointmentCodeFa(code: number): string {
  return toFaDigits(formatAppointmentCode(code))
}

export function visitTypeLabel(visitType: string): string {
  return visitType === 'virtual' ? 'ویزیت مجازی' : 'ویزیت حضوری'
}

export function paymentStatusLabel(status: AppointmentPaymentStatus, amountDue: number): string {
  if (status === 'paid') return 'پرداخت‌شده'
  if (status === 'deposit_paid') return 'بیعانه پرداخت شد'
  if (status === 'pay_at_clinic') return 'پرداخت در مطب'
  if (amountDue <= 0) return 'رایگان'
  return 'در انتظار پرداخت'
}
